import React, { useEffect, useState } from 'react'
import { Grid } from '@mui/material'
import FilterTextField from './Components/FilterTextField';
import DrawerMoreFilters from './Components/drawer/DrawerMoreFilters';
import ButtonLightGray from './Components/ButtonLightGray';
import ChipFactory from './Components/chips/ChipFactory';
import { IOperationFilter, Modality } from '../../Store/Operations/types';
import { GridButton } from './Components/grid/GridButton';
import { BoxButton } from './Components/BoxButton';
import GridContainer from './Components/grid/GridContainer';
import FilterOperationToggleButton from './Components/FilterOperationToggleButton';

interface IOperationFilterProps {
    onFilterApply: (filter: IOperationFilter) => void
    filter: IOperationFilter
}

const OperationFilter: React.FC<IOperationFilterProps> = (props) => {

    const [operationFilter, setOperationFilter] = useState<IOperationFilter>(props.filter)
    const [uuidRegexValid, setUUIDRegexValid] = useState(true);
    const [openMoreFilters, setOpenMoreFilters] = useState<boolean>(false)

    useEffect(() => {
        setOperationFilter(props.filter)
    }, [props.filter]);

    const getDataTableType = (): "operations-face" | "operations-voice" | "operations-fingers" => {
        const modality = props.filter?.modalities?.[0] ?? Modality.FACE_MODALITY
        switch (modality){
            case Modality.FACE_MODALITY:
                return "operations-face"
            case Modality.VOICE_MODALITY:
                return "operations-voice"
            case Modality.FINGERS_MODALITY:
                return "operations-fingers"
            default:
                return "operations-face"
        }
    }

    const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        if (event.key === 'Enter') {
            onFilterApply(operationFilter)
        }   
    }

    const handleUUIDChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        setOperationFilter({...operationFilter, uuid: event.target.value})
        try {
            new RegExp(event.target.value);
        } catch(e) {
            setUUIDRegexValid(false)
            return;
        }
        setUUIDRegexValid(true)
    }

    const setFilterChip = (filter: IOperationFilter) => {
        props.onFilterApply(filter)
        setOperationFilter(filter)
    }

    const resetFilter = () => {
        setOperationFilter({})
        props.onFilterApply({modalities: props.filter.modalities})
    }

    const onFilterApply = (filter: IOperationFilter) => {
        setOperationFilter(filter)
        props.onFilterApply(filter);
        setOpenMoreFilters(false)
    }

    return (
        <>
            <GridContainer container>
                <Grid item xs={12} md={5}>
                    <FilterTextField
                        style={{height: "100%"}}
                        variant='outlined'
                        spellCheck="false"
                        fullWidth
                        label="Regex"
                        size="small"
                        placeholder='Click to filter UUID'
                        value={operationFilter.uuid}
                        onChange={(event) => handleUUIDChange(event)}
                        error={!uuidRegexValid}
                        onClick={() => onFilterApply(operationFilter)}
                        onInputKeyDown={handleKeyDown}
                    />
                </Grid>
                <GridButton item xs={6} md={3}>
                    <BoxButton>
                        <ButtonLightGray
                            onClick={() => setOpenMoreFilters(true)}
                            variant='text'
                            color="primary"
                            style={{height: "100%"}}
                        >
                            More filters
                        </ButtonLightGray>
                    </BoxButton>

                </GridButton>
                <GridButton item container xs={6} md={4} justifyContent="flex-end">
                    <FilterOperationToggleButton
                        filter={operationFilter}
                        setFilter={onFilterApply}
                    />
                </GridButton>
                <ChipFactory
                    filter={props.filter}
                    setChip={setFilterChip}
                    clearFilter={resetFilter}
                    ignoreModality
                />
            </GridContainer>
            <DrawerMoreFilters
                anchor='right'
                type={getDataTableType()}
                filter={operationFilter}
                setFilter={setOperationFilter}
                open={openMoreFilters}
                onClose={() => setOpenMoreFilters(false)}
                resetFilter={resetFilter}
                onFilterApply={onFilterApply}
            />
        </>
    )
}

export default OperationFilter